<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <h4>Información de donde se encuentra el vehículo para su reparacion</h4>
      <div class="row">
        <!-- DIRECCION -->
        <div v-if="isFieldVisible('repairing_facility_address')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="repairing_facility_address" class="form-label text-left">{{ getFieldDescription('repairing_facility_address') }}</label>
            <input
              type="text"
              class="form-control"
              name="repairing_facility_address"
              v-model="formData.repairing_facility_address"
              required="required"
              maxlength="191"
              @input="() => emitFieldChanged('repairing_facility_address')"
            />
          </div>
        </div>
        <!-- CONTACTO -->
        <div v-if="isFieldVisible('repairing_facility_contact_name')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="repairing_facility_contact_name" class="form-label text-left">{{ getFieldDescription('repairing_facility_contact_name') }}</label>
            <input
              type="text"
              class="form-control"
              name="repairing_facility_contact_name"
              v-model="formData.repairing_facility_contact_name"
              required="required"
              maxlength="191"
              @input="() => emitFieldChanged('repairing_facility_contact_name')"
            />
          </div>
        </div>
        <!-- TELEFONO -->
        <div v-if="isFieldVisible('repairing_facility_contact_phone')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="repairing_facility_contact_phone" class="form-label text-left">{{ getFieldDescription('repairing_facility_contact_phone') }}</label>
            <input
              type="text"
              class="form-control"
              name="repairing_facility_contact_phone"
              v-model="formData.repairing_facility_contact_phone"
              required="required"
              maxlength="10"
              @input="() => emitFieldChanged('repairing_facility_contact_phone')"
            />
          </div>
        </div>
        <!-- EMAIL -->
        <!-- <div v-if="isFieldVisible('repairing_facility_contact_phone')" class="col-md-3 mt-3">
          <div class="form-group bordered">
            <label for="repairing_facility_contact_email" class="form-label text-left">Lugar de reparacion - Contacto Email (Opcional)</label>
            <input
              type="text"
              class="form-control"
              name="repairing_facility_contact_email"
              v-model="formData.repairing_facility_contact_email"
              maxlength="150"
              @input="() => emitFieldChanged('repairing_facility_contact_email')"
            />
          </div>
        </div> -->

      </div>
      <hr class="custom-hr mt-4"/>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  name: 'FormRepairingLocation',
  props: {
    data: Object,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);

    const formData = ref({
      repairing_facility_address: null,
      repairing_facility_contact_name: null,
      repairing_facility_contact_phone: null,
      /* repairing_facility_contact_email: null, */
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (
          dataCompany.value &&
          (dataCompany.value.repairing_facility_address ||
            dataCompany.value.repairing_facility_contact_name ||
            dataCompany.value.repairing_facility_contact_phone)
        );
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const emitFieldChanged = () => {
      emit('formDataChanged', formData.value);
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      formData,
      emitFieldChanged,
    };
  },
};
</script>
